/**
 * @module explore/components/projects_page
 */
import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import ProjectTile from 'common/components/project_tile';
import GalleryNoResults from 'common/components/gallery_no_results';
import { LoadingIndicator } from 'common/components/preloader';
import { PROJECTS_RESOURCE_NAME } from 'explore/constants';

/**
 * Component rendering list of projects
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const ProjectsPage = (props) => {
  if (props.fetching) {
    return (
      <div className="small-16 large-12 columns explore-creatives">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="small-16 large-12 columns explore-projects">
      { props.projects.length ?
        props.projects.map((item, i) => {
          const shouldGoToEntries = !(
            item.private_gallery || item.nda_required || props.user.profile_data.is_creative
          );

          return (
            <ProjectTile
              item={item}
              categories={props.categories}
              industries={props.industries}
              authenticated={props.user.logged_in}
              userType={props.user.profile_data ? props.user.profile_data.user_type : 'Anonymous'}
              key={v4()}
              showTools={true}
              subcategoryFilter={{
                resourceName: PROJECTS_RESOURCE_NAME,
              }}
              showTooltips={true}
              append={shouldGoToEntries? 'entries' : undefined}
              linkEntriesStats={shouldGoToEntries}
            />
          );
        })
        : <GalleryNoResults />
      }
    </div>
  );
};

ProjectsPage.propTypes = {
  fetching: PropTypes.bool,
  projects: PropTypes.array,
  categories: PropTypes.array,
  user: PropTypes.object,
};

export default ProjectsPage;



// WEBPACK FOOTER //
// ./explore/components/projects_page.jsx